import { coreInstance, backendVersion, globalAxios } from "@/axios-path.js";

export default {
  namespaced: true,
  state: {
    store_list_pagination: {
      rowsPerPage: 50,
      page: 1,
      totalItems: 0,
      descending: false,
      sortBy: null,
    },
    store_services: [],
    loading_index: null,
    store_type: [],
    load_edit_index: null,
    store_list: [],
    store_detail: null,
    store_popular_list: [],
    choiceList: [],
  },
  mutations: {
    resetStateStoreService(state) {
      state.store_services = [];
    },
    resetStateStoreType(state) {
      state.store_type = [];
    },
    resetStateStoreList(state) {
      state.store_list = [];
    },
    resetStateStoreDetail(state) {
      state.store_detail = null;
    },
    setStoreListPagination(state, data) {
      state.store_list_pagination = data;
    },
    resetState(state) {
      state.store_list = [];
      state.store_type = [];
    },
    getDataService(state, data) {
      state.store_services = data;
    },
    addService(state, data) {
      state.store_services.push(data);
    },
    editService(state, index) {
      state.loading_index = index;
    },
    delService(state, data) {
      const index = state.store_services.indexOf(data);
      state.store_services.splice(index, 1);
    },
    getDataType(state, data) {
      state.store_type = data;
    },
    getDataType1(state, data) {
      state.store_type.store_types = data;
    },
    addStoreType(state, data) {
      state.store_type.store_types.push(data);
    },
    editStoreType(state, index) {
      state.load_edit_index = index;
    },
    deleteStoreType(state, data) {
      let index = state.store_type.store_types.indexOf(data);
      state.store_type.store_types.splice(index, 1);
    },
    getStoreList(state, data) {
      state.store_list = data;
    },
    deActivateStoreList(state, item) {
      const index = state.store_list.findIndex(
        (val) => val.store_id == item.data.store_id
      );
      state.store_list[index].store_active = item.value;
    },
    addStoreList(state, data) {
      state.store_list.push(data);
    },
    getStoreDetail(state, data) {
      state.store_detail = data;
    },
    editStoreInfo(state, res_data) {
      Object.assign(state.store_detail, res_data);
    },
    editStoreAddress(state, res_data) {
      Object.assign(state.store_detail, res_data);
    },
    editDailyAndPre(state, res_data) {
      Object.assign(state.store_detail.store_time, res_data);
    },
    addSpecialTime(state, res_data) {
      for (let key in res_data) {
        state.store_detail.store_close.push(res_data[key]);
      }
    },
    delSpecialTime(state, data) {
      let index = state.store_detail.store_close.indexOf(data);
      state.store_detail.store_close.splice(index, 1);
    },
    getStorepopularList(state, data) {
      state.store_popular_list = data;
    },
    setChoiceByStore(state, data) {
      state.choiceList = data;
    },
  },
  actions: {
    fetchReviewList({ dispatch }, payload) {
      let url = `/api/v1/${payload.province}/merChant/restaurant/getReviewlist`;
      let axiosConfig = {
        params: payload.querys,
      };
      return globalAxios
        .get(url, axiosConfig)
        .then((res) => {
          return res;
        })
        .catch((err) => {
          dispatch("disconnectNetwork", err, { root: true });
          return false;
        });
    },
    async getAllStoreByUser({ dispatch, commit }, user_id) {
      let url =
        backendVersion.version +
        "/merChant/all_store_by_user_merchant?user_id=" +
        user_id;
      let res = await dispatch("fetchGeneral/merchantGetData", url, {
        root: true,
      });
      if (typeof res == "boolean" && res == false) {
        return [];
      } else {
        return res.data;
      }
    },
    async changeStatusStorePartner({ rootState, dispatch }, form) {
      if (form.store_partner_service_charge) {
        form.store_partner_service_charge = parseFloat(
          form.store_partner_service_charge
        );
      }
      let url = `/edit/storePartner/${form.store_id}`;
      let res = await dispatch(
        "fetchGeneral/axiosPathPutData",
        { url, form },
        { root: true }
      );
      if (typeof res == "boolean" && res == false) {
        return false;
      } else {
        return true;
      }
    },
    async manualGetStoreListByProvince(
      { commit, rootState, dispatch },
      provinceID
    ) {
      let province = rootState.fetchProvinceBack.provinceData.find(
        (val) => val.province_id == provinceID
      );
      province = province.province_name_en.replace(" ", "").toLowerCase();
      return coreInstance
        .get(
          backendVersion.version +
          "/service/GetServiceDiscovery/" +
          province +
          "/web_back_office"
        )
        .then(async (res) => {
          let url = res.data.fetchStoreBack_getStoreList;
          let response = await dispatch("fetchGeneral/axiosPathGetData", url, {
            root: true,
          });
          if (typeof response == "boolean" && response == false) {
            return false;
          } else {
            return response;
          }
        })
        .catch((err) => false);
    },
    async manualGetStoreListByProvinceName(
      { commit, rootState, dispatch },
      provinceName
    ) {
      let province = provinceName.replace(" ", "").toLowerCase();
      return coreInstance
        .get(
          backendVersion.version +
          "/service/GetServiceDiscovery/" +
          province +
          "/web_back_office"
        )
        .then(async (res) => {
          let url = res.data.fetchStoreBack_getStoreList;
          let response = await dispatch("fetchGeneral/axiosPathGetData", url, {
            root: true,
          });
          if (typeof response == "boolean" && response == false) {
            return false;
          } else {
            return response;
          }
        })
        .catch((err) => false);
    },
    async manualGetStoreDetailByProvinceName(
      { commit, rootState, dispatch },
      configPATH
    ) {
      let province = configPATH.province.replace(" ", "").toLowerCase();
      return coreInstance
        .get(
          backendVersion.version +
          "/service/GetServiceDiscovery/" +
          province +
          "/web_back_office"
        )
        .then(async (res) => {
          let url = res.data.getStoreDetail + configPATH.storeId;
          let response = await dispatch("fetchGeneral/axiosPathGetData", url, {
            root: true,
          });
          if (typeof response === false) {
            return false;
          } else {
            return response;
          }
        })
        .catch((err) => false);
    },
    async changeFreeDeliveryStatus({ commit, rootState, dispatch }, form) {
      let url =
        rootState.api_urls.store_changeFreeDeliveryStatus + form.store_id;
      let res = await dispatch(
        "fetchGeneral/axiosPathPutData",
        { url, form },
        { root: true }
      );
      if (typeof res == "boolean" && res == false) {
        return false;
      } else {
        return res.msg;
      }
    },
    async SortStore({ rootState, dispatch }, store_list) {
      let url = rootState.api_urls.fetchStoreBack_SortStore;
      let res = await dispatch(
        "fetchGeneral/axiosPathPutData",
        { url, form: store_list },
        { root: true }
      );
      if (typeof res == "boolean" && res == false) {
        return 3;
      } else {
        return 2;
      }
    },
    async applyStorePopular({ rootState, dispatch }, popular_list) {
      let url = rootState.api_urls.fetchStoreBack_applyStorePopular;
      let res = await dispatch(
        "fetchGeneral/axiosPathPostData",
        { url, form: popular_list },
        { root: true }
      );
      if (typeof res == "boolean" && res == false) {
        return 3;
      } else {
        return 2;
      }
    },
    async getPopularList({ commit, rootState, dispatch }) {
      let url = rootState.api_urls.fetchStoreBack_getPopularList;
      let res = await dispatch("fetchGeneral/axiosPathGetData", url, {
        root: true,
      });
      if (typeof res == "boolean" && res == false) {
        return false;
      } else {
        commit("getStorepopularList", res);
        return true;
      }
    },
    async delSpecialTime({ commit, rootState, dispatch }, data) {
      let url = rootState.api_urls.deleteSpecialTimeStore + data.store_close_id;
      let res = await dispatch("fetchGeneral/axiosPathDeleteData", url, {
        root: true,
      });
      if (typeof res == "boolean" && res == false) {
        return false;
      } else {
        commit("delSpecialTime", data);
        return false;
      }
    },
    async addSpecialTime({ commit, rootState, dispatch }, form_data) {
      let isCommit = form_data.is_commit;
      delete form_data.is_commit;

      let url = rootState.api_urls.addSpecialTimestore;
      let res = await dispatch(
        "fetchGeneral/axiosPathPostData",
        { url, form: form_data },
        { root: true }
      );
      if (typeof res == "boolean" && res == false) {
        return false;
      } else {
        if (res.mgs && res.mgs == " close date is already to used") {
          return false;
        }
        if (isCommit != false) commit("addSpecialTime", res);

        return true;
      }
    },
    async editDailyAndPre({ commit, rootState, dispatch }, edit_detail) {
      let url = rootState.api_urls.editDailyAndPre + edit_detail.store_time_id;
      let res = await dispatch(
        "fetchGeneral/axiosPathPutData",
        { url, form: edit_detail },
        { root: true }
      );
      if (typeof res == "boolean" && res == false) {
        return false;
      } else {
        commit("editDailyAndPre", res);
        return true;
      }
    },
    async editStoreAddress({ commit, rootState, dispatch }, edit_detail) {
      let url = rootState.api_urls.editStoreAddress + edit_detail.store_id;
      let res = await dispatch(
        "fetchGeneral/axiosPathPutData",
        { url, form: edit_detail },
        { root: true }
      );
      if (typeof res == "boolean" && res == false) {
        return false;
      } else {
        commit("editStoreAddress", res);
        return true;
      }
    },
    async editStoreInfo({ commit, rootState, dispatch }, edit_detail) {
      let url = rootState.api_urls.editStoreInfo + edit_detail.store_id;
      let res = await dispatch(
        "fetchGeneral/axiosPathPutData",
        { url, form: edit_detail },
        { root: true }
      );
      if (typeof res == "boolean" && res == false) {
        return false;
      } else {
        commit("editStoreInfo", res);
        return true;
      }
    },
    async getStoreDetailAdd({ commit, rootState, dispatch, state }, store_id) {
      state.store_detail = null;
      let url = rootState.api_urls.getStoreDetail + store_id;
      let res = await dispatch("fetchGeneral/axiosPathGetData", url, {
        root: true,
      });
      if (typeof res == "boolean" && res == false) {
      } else {
        commit("getStoreDetail", res);
      }
    },
    async getStoreDetail({ commit, rootState, dispatch, state }, store_id) {
      let url = rootState.api_urls.getStoreDetail + store_id;
      let res = await dispatch("fetchGeneral/axiosPathGetData", url, {
        root: true,
      });
      if (typeof res == "boolean" && res == false) {
      } else {
        commit("getStoreDetail", res);
        rootState.storeBack.store_name = res.store.store_name_th;
        return res;
      }
    },
    async addStoreList({ commit, rootState, dispatch }, sendData) {
      let url = rootState.api_urls.fetchStoreBack_addStoreList;
      let res = await dispatch(
        "fetchGeneral/axiosPathPostData",
        { url, form: sendData },
        { root: true }
      );
      if (typeof res == "boolean" && res == false) {
        return 99;
      } else {
        if (res.msg == 0 || res.msg == 1) {
        } else {
          commit("addStoreList", res);
        }
        let checkSuccess = {
          msg: res.msg,
          store_id: res.store_id,
        };
        return checkSuccess;
      }
    },
    async deActivateStoreList({ commit, rootState, dispatch }, data) {
      const sendData = {
        store_id: data.item.store_id,
        store_active: data.value,
      };
      let url =
        rootState.api_urls.fetchStoreBack_deActivateStoreList +
        data.item.store_id;
      let res = await dispatch(
        "fetchGeneral/axiosPathPutData",
        { url, form: sendData },
        { root: true }
      );
      if (typeof res == "boolean" && res == false) {
        return 3;
      } else {
        commit("deActivateStoreList", { data: data.item, value: data.value });
        return true;
      }
    },
    async getStoreList({ commit, rootState, state, dispatch }) {
      let url = rootState.api_urls.fetchStoreBack_getStoreList;
      let res = await dispatch("fetchGeneral/axiosPathGetData", url, {
        root: true,
      });
      if (typeof res == "boolean" && res == false) {
        return 3;
      } else {
        commit("getStoreList", res);
        return res;
      }
    },
    async deleteStoreType({ commit, rootState, dispatch }, data) {
      let url =
        rootState.api_urls.fetchStoreBack_deleteStoreType + data.store_type_id;
      let res = await dispatch("fetchGeneral/axiosPathDeleteData", url, {
        root: true,
      });
      if (typeof res == "boolean" && res == false) {
      } else {
        commit("deleteStoreType", data);
      }
    },
    async editStoreType({ commit, state, rootState, dispatch }, data) {
      let index = state.store_type.store_types.indexOf(data);
      commit("editStoreType", index);
      let url =
        rootState.api_urls.fetchStoreBack_editStoreType + data.store_type_id;
      let res = await dispatch(
        "fetchGeneral/axiosPathPutData",
        { url, form: data },
        { root: true }
      );
      if (typeof res == "boolean" && res == false) {
        return false;
      } else {
        commit("editStoreType", null);
      }
    },
    async addStoreType({ commit, rootState, dispatch }, data) {
      let url = rootState.api_urls.fetchStoreBack_addStoreType;
      let res = await dispatch(
        "fetchGeneral/axiosPathPostData",
        { url, form: data },
        { root: true }
      );
      if (typeof res == "boolean" && res == false) {
      } else {
        commit("addStoreType", res);
      }
    },
    async getDataType({ commit, state, rootState, dispatch }) {
      let url = rootState.api_urls.fetchStoreBack_getDataType;
      let res = await dispatch("fetchGeneral/axiosPathGetData", url, {
        root: true,
      });
      if (typeof res == "boolean" && res == false) {
        return 3;
      } else {
        commit("getDataType", res);
        return "No data available";
      }
    },
    async getDataService({ commit, state, rootState, dispatch }) {
      state.store_services = [];
      let url = rootState.api_urls.fetchStoreBack_getDataService;
      let res = await dispatch("fetchGeneral/axiosPathGetData", url, {
        root: true,
      });
      if (typeof res == "boolean" && res == false) {
        return res;
      } else {
        commit("getDataService", res);
        return " No data available";
      }
    },
    async addService({ commit, rootState, dispatch }, data) {
      let url = rootState.api_urls.fetchStoreBack_addService;
      let res = await dispatch(
        "fetchGeneral/axiosPathPostData",
        { url, form: data },
        { root: true }
      );
      if (typeof res == "boolean" && res == false) {
      } else {
        commit("addService", res);
      }
    },
    async editService({ commit, state, rootState, dispatch }, data) {
      const index = state.store_services.indexOf(data);
      commit("editService", index);
      let url =
        rootState.api_urls.fetchStoreBack_editService + data.store_service_id;
      let res = await dispatch(
        "fetchGeneral/axiosPathPutData",
        { url, form: data },
        { root: true }
      );
      if (typeof res == "boolean" && res == false) {
        commit("editService", null);
        return false;
      } else {
        commit("editService", null);
        return true;
      }
    },
    async delService({ commit, rootState, dispatch }, data) {
      let url =
        rootState.api_urls.fetchStoreBack_delService + data.store_service_id;
      let res = await dispatch("fetchGeneral/axiosPathDeleteData", url, {
        root: true,
      });
      if (typeof res == "boolean" && res == false) {
      } else {
        commit("delService", data);
      }
    },
    async editStoreBusinessImage({ dispatch }, payload) {
      // console.log(url)
      let url = `/api/v1/${payload.province}/Office/uploadStoreBusinessImage/${payload.store_id
        }`;
      return globalAxios
        .post(url, payload.form)
        .then((res) => {
          return true;
        })
        .catch((err) => {
          dispatch("disconnectNetwork", err, { root: true });
          return false;
        });
    },
    async editStoreBankDetail({ dispatch }, payload) {
      // console.log(url)
      let url = `/api/v1/${payload.province}/Office/createStoreBank`;
      return globalAxios
        .put(url, payload.form)
        .then((res) => {
          return true;
        })
        .catch((err) => {
          dispatch("disconnectNetwork", err, { root: true });
          return false;
        });
    },
    async createStoreBankDetail({ dispatch }, payload) {
      // console.log(url)

      let url = `/api/v1/${payload.province}/Office/createStoreBank`;
      return globalAxios
        .post(url, payload.form)
        .then((res) => {
          return true;
        })
        .catch((err) => {
          dispatch("disconnectNetwork", err, { root: true });
          return false;
        });
    },
    async getChoiceByStore({ dispatch, commit }, payload) {
      let url = `/api/v1/${payload.province}/get/choice/by_store?store_id=${payload.storeID
        }`;
      return globalAxios
        .get(url)
        .then((res) => {
          commit("setChoiceByStore", res.data);
          return res;
        })
        .catch((err) => {
          dispatch("disconnectNetwork", err, { root: true });
          return [];
        });
    },
    async changsStatusChoice({ dispatch }, payload) {
      let body = {
        choice_id: payload.choice_id,
        choice_status: payload.choice_status,
      };
      let url = `/api/v1/${payload.province}/changs_status/choice`;
      return globalAxios
        .put(url, body)
        .then((res) => {
          return true;
        })
        .catch((err) => {
          dispatch("disconnectNetwork", err, { root: true });
          return false;
        });
    },
    async fetchStoreByPackage({ dispatch }, { packages, province }) {
      let url = `/api/v1/${province}/stores/package`;
      return globalAxios
        .post(url, { packages: packages })
        .then((res) => {
          if (res.msg == false) return [];
          return res.data.stores;
        })
        .catch((err) => {
          dispatch("disconnectNetwork", err, { root: true });
          return [];
        });
    },
    async fetchStoreListCore({ dispatch }, province) {
      let url = `/api/v1/${province}/stores`;
      return globalAxios
        .get(url)
        .then((res) => {
          return res;
        })
        .catch((err) => {
          dispatch("disconnectNetwork", err, { root: true });
          return [];
        });
      //
    },
    async removeOrderReview({ dispatch }, { province, orderReviewId }) {
      const url = `/api/v1/${province}/order-review-revert/${orderReviewId}`;
      try {
        await globalAxios.delete(url);
        return true;
      } catch (err) {
        dispatch("disconnectNetwork", err, { root: true });
        return false;
      }
    },
  },
  getters: {
    autocompleteStoreFreedelivery(state) {
      let store_list = [];
      for (let val of state.store_list) {
        if (val.store_free_delivery == true) {
          store_list.push({
            store_id: val.store_id,
            store_name_th: val.store_name_th ? val.store_name_th : "",
            store_partner: val.store_partner,
          });
        }
      }
      return store_list;
    },
    autocompleteStore(state) {
      let store_list = [];
      for (let val of state.store_list) {
        store_list.push({
          store_id: val.store_id,
          store_name_th: val.store_name_th ? val.store_name_th : "",
          store_partner: val.store_partner,
        });
      }
      return store_list;
    },
    storeListTable(state) {
      let store_list = JSON.parse(JSON.stringify(state.store_list));
      for (let item of store_list) {
        let store_tel_name_temp = "";
        if (item.store_tel.constructor === Array) {
          for (let val of item.store_tel) {
            let index = item.store_tel.indexOf(val);
            if (index <= item.store_tel.length - 1) {
              store_tel_name_temp =
                store_tel_name_temp + item.store_country_tel + val.tel;
            }
            if (index < item.store_tel.length - 1) {
              store_tel_name_temp = store_tel_name_temp + ",";
            }
          }
        }
        item.store_tel_name_temp = store_tel_name_temp;
      }
      return store_list;
    },
    baseDistanceStore(state) {
      return state.store_list;
    },
    storeListFoodAddOn(state) {
      return state.store_list;
    },
  },
};
